import { onMounted, onUnmounted, ref } from 'vue';

export const useIsDarkTheme = () => {
  const isDark = ref(
    typeof document !== 'undefined' && document.body.classList.contains('dark')
  );

  let observer;

  const sync = () => {
    isDark.value = document.body.classList.contains('dark');
  };

  onMounted(() => {
    sync();
    observer = new MutationObserver(sync);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  });

  onUnmounted(() => observer?.disconnect());

  return isDark;
};
